module.exports = __webpack_public_path__ + "static/media/analysis.473a3c99.svg";